import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Web config for the Kalan Firebase project.
// Values should be provided via environment variables:
// - REACT_APP_FIREBASE_API_KEY
// - REACT_APP_FIREBASE_AUTH_DOMAIN
// - REACT_APP_FIREBASE_PROJECT_ID (expected: "slam-2fe64")
// - REACT_APP_FIREBASE_STORAGE_BUCKET
// - REACT_APP_FIREBASE_MESSAGING_SENDER_ID
// - REACT_APP_FIREBASE_APP_ID
// - REACT_APP_FIREBASE_MEASUREMENT_ID (optional)

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Use the custom Firestore database name `teaching` to match the mobile app.
export const db = getFirestore(app, 'teaching');
export const storage = getStorage(app);

